module.exports = "{% extends 'base.html.twig' %}\n\n{% block body %}\n{{ react_component('MoviesApp', {'props': props}) }}\n{% endblock %}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/exercise-routing-list2.twig.txt
// module id = 443
// module chunks = 211874487586253